import { useQuery } from '@tanstack/react-query';
import { getProviderActivationEvents } from '@uplift/api';

import { providerQueryKeys } from './providerQueryKeys';
import { BaseQueryOpts } from '../baseTypes';

export const useProviderActivationEvents = (providerId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: providerQueryKeys.activationEvents(providerId),
    staleTime: 5000,
    queryFn: async () => {
      const events = await getProviderActivationEvents(providerId);

      return events.data;
    },
    ...opts,
  });
};
